import '@yumi/legacy/config/window-secrets';

// core-js polyfills for legacy Android WebView (API 29 / Chrome 91) that lacks
// native Array.prototype.at support and crashes pdfjs KeyboardManager on startup.
import 'core-js/modules/es.array.at';
// Nx 15 configures preset-env with the Core-JS 3.0 baseline and rewrites entry
// imports, which otherwise drops modules added after 3.0. Keep this synchronous
// wrapper outside Babel so Webpack physically bundles the installed implementation.
import './polyfills/array-at.cjs';
/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
